export default function initSectionToggler() {
	const togglerBlocks = document.querySelectorAll('.section-toggler-block');
	
	// Helper function to get URL parameter
	function getUrlParameter(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name);
	}
	
	// Helper function to update URL with viewing parameter
	function updateUrl(tabIndex) {
		const url = new URL(window.location);
		// Clear all query parameters except viewing
		url.search = '';
		url.searchParams.set('viewing', tabIndex);
		window.history.replaceState({}, '', url);
	}
	
	togglerBlocks.forEach(togglerBlock => {
		const togglerId = togglerBlock.getAttribute('data-toggler-id');
		const togglerTabs = togglerBlock.querySelectorAll(`[data-toggler="${togglerId}"]`);
		
		function hideAllTabs() {
			const allTabItems = document.querySelectorAll('.tab');
			allTabItems.forEach(item => {
				item.style.display = 'none';
			});
		}
		
		function showTabContent(selector) {
			const targetElements = document.querySelectorAll(selector + ", ."+selector);
			console.log(targetElements, selector);
			targetElements.forEach(element => {
				element.style.display = '';
			});
		}
		
		// Helper function to change interactive tool post type
		function changeInteractiveToolPostType(postTypeName, toolInstanceId) {
			if (window.crToolInstances && window.crToolInstances[toolInstanceId] && window.crToolInstances[toolInstanceId].setActivePostTypeByName) {
				window.crToolInstances[toolInstanceId].setActivePostTypeByName(postTypeName);
			}
		}
		
		function setActiveTab(activeTab) {
			togglerTabs.forEach(tab => {
				tab.classList.remove('active');
			});
			activeTab.classList.add('active');
			changeInteractiveToolPostType(activeTab.getAttribute('data-selector').replace(".", ""), 'interactive-tool-1');
		}
		
		function activateTab(tab, updateHistory = true) {
			const selector = tab.getAttribute('data-selector');
			const tabIndex = Array.from(togglerTabs).indexOf(tab);
			
			// Hide all tab content
			hideAllTabs();
			
			// Show selected content
			showTabContent(selector);
			
			// Set active tab
			setActiveTab(tab);
			
			// Update URL with viewing parameter
			if (updateHistory) {
				updateUrl(tabIndex);
			}
			
			// Emit custom event for external handling
			const event = new CustomEvent('sectionToggled', {
				detail: { 
					selector: selector,
					tab: tab,
					togglerBlock: togglerBlock,
					togglerId: togglerId,
					tabIndex: tabIndex
				}
			});
			document.dispatchEvent(event);
		}
		
		// Add click handlers to tabs
		togglerTabs.forEach(tab => {
			tab.addEventListener('click', function() {
				activateTab(this, true);
			});
		});
		
		// Initialize tab based on viewing parameter or default to first
		if (togglerTabs.length > 0) {
			const viewingParam = getUrlParameter('viewing');
			let defaultTab = togglerTabs[0]; // Default to first tab
			
			// If viewing parameter exists and is valid, use that tab
			if (viewingParam !== null) {
				const tabIndex = parseInt(viewingParam, 10);
				if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < togglerTabs.length) {
					defaultTab = togglerTabs[tabIndex];
				}
			}
			
			// Activate the default tab (don't update history on initial load)
			activateTab(defaultTab, false);
		}
	});
}
